// For use on the client
const getMetaContentfulEnv = () => window.CONTENTFUL_ENV;

export { getMetaContentfulEnv };
